import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import TableContainer from "../../components/Common/TableContainer.js";
import { Link, useNavigate, useParams } from "react-router-dom";
import Select, { components } from "react-select";
import useFetchList from "../../utils/useFetchLIst";
import { loaderOverlay } from "../../Style/loaderOverly";
import { LoaderCreatePage } from "../Loader/Loader";
import { baseURL, getRecords, saveRecords } from "../../services/api.service";
import formatDateTime from "../../custom/Utils/formatDateTime";
import { Button, Col, Row } from "reactstrap";
import { toast } from "react-toastify";
import TextInput from "../../custom/components/Text-Input/TextInput.js";
import SelectInput from "../../custom/components/Select-Input/SelectInput.js";
import { ChevronsDown, Download } from "react-feather";
import MultiSelectInput from "../../custom/components/MultiSelect-Input/MultiSelectInput.js";
// import useFetchList from "../../../utils/useFetchList";

const ViewStock = () => {
  const { id } = useParams();
  const [formData, setFormData] = useState({
    material: "",
  });
  const [loadingData, setLoadingData] = useState(false);
  const [selectedMaterial, setSelectedMaterial] = useState(null); // Add this line
  const [inventoryData, setInventoryData] = useState(null);
  const [errors, setErrors] = useState({});
  const [materialOptions, setMaterialOptions] = useState([]);
  const [showStockData, setShowStockData] = useState(false);
  const schema = localStorage.getItem("schema");
  const [expandedRows, setExpandedRows] = useState({});
  const [techniciansByMaterial, setTechniciansByMaterial] = useState({});
  const [loadingTechnicians, setLoadingTechnicians] = useState(false);
  const [expandedTechnician, setExpandedTechnician] = useState(null);
  const [technicianDetails, setTechnicianDetails] = useState({});
  const [loadingTechnicianDetails, setLoadingTechnicianDetails] =
    useState(false);

  // const payload = {
  //   modelName: "material_masters",
  //   schema:localStorage.getItem("schema"),
  //   whereCondition: {
  //     is_active: true,
  //   },
  //   include: [
  //     {
  //       model: "category_masters",
  //       as: "category",
  //       where: {
  //         type: 1,
  //       },
  //       required: true,
  //     },
  //   ],
  // };

  // const {
  //   data: materialData,
  //   loading,
  //   error,
  // } = useFetchList("/getRecords", payload);
  useEffect(() => {
    getItem();
  }, []);
  const getItem = async (e) => {
    const schema = localStorage.getItem("schema");

    const payload = {
      modelName: "material_masters",
      schema: schema,
      whereCondition: {
        is_active: true,
      },
      include: [
        {
          model: "category_masters",
          as: "category",
          where: {
            type: 1,
          },
          required: true,
        },
      ],
    };
    setLoadingData(true);

    try {
      const res = await getRecords(payload, "/getRecords");
      const materialData = res?.data || [];
      const options = materialData.map((material) => ({
        value: material?.id,
        label: material?.gmds_code || material?.name,
      }));
      setMaterialOptions(options);
    } catch {
      toast.error("Something went wrong");
    } finally {
      setLoadingData(false);
    }
  };

  const handleChange = (e) => {
    const { value } = e.target;

    setFormData({ material: value });

    if (Array.isArray(value) && value.length > 0) {
      setSelectedMaterial(value);
      setErrors({ material: null });
      setShowStockData(false);
    } else {
      setSelectedMaterial([]);
      setErrors({ material: "Item cannot be blank." });
      setShowStockData(false);
    }
    setTechniciansByMaterial({});
    setExpandedRows({});
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setInventoryData(null);
    setTechniciansByMaterial({});
    setExpandedRows({});
    setExpandedTechnician({});
    setTechnicianDetails({});
    setShowStockData(false);
    if (!Array.isArray(selectedMaterial) || selectedMaterial.length === 0) {
      setErrors({
        material: "Item cannot be blank.",
      });
      return;
    }
    setErrors({ material: null });

    setLoadingData(true);

    try {
      const materialIds = selectedMaterial.map((item) => item.value);

      const payload = {
        material_id: materialIds,
        include: [
          {
            model: "material_masters",
            as: "material",
          },
        ],
      };

      const responseData = await saveRecords(
        payload,
        "/materials/quantity-summary",
      );
      setInventoryData(responseData?.data || []);
      setShowStockData(true);
    } catch (error) {
      console.error(error);
      toast.error("An unexpected error occurred. Please try again.");
      setShowStockData(false);
    } finally {
      setLoadingData(false);
    }
  };

  const getTechniciansByMaterial = async (materialId) => {
    setExpandedTechnician({});
    setTechnicianDetails({});
    setExpandedRows((prev) => ({
      ...prev,
      [materialId]: !prev[materialId],
    }));

    // 🔹 If already fetched, do not call API again
    if (techniciansByMaterial[materialId]) return;

    setLoadingTechnicians(true);
    try {
      const payload = {
        material_id: materialId,
      };

      const responseData = await getRecords(
        payload,
        "/technicians-by-material",
      );

      setTechniciansByMaterial((prev) => ({
        ...prev,
        [materialId]: responseData?.data || [],
      }));
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong! Please try again");
    } finally {
      setLoadingTechnicians(false);
    }
  };

  const getTechnicianDetails = async (materialId, technicianId) => {
    // toggle (only one allowed)
    if (expandedTechnician === technicianId) {
      setExpandedTechnician(null);
      return;
    }

    setExpandedTechnician(technicianId);
    setLoadingTechnicianDetails(true);

    try {
      const payload = {
        technician_id: technicianId,
        material_id: materialId,
      };
      const response = await getRecords(
        payload,
        "/inventory/technician-material-logs",
      );

      setTechnicianDetails((prev) => ({
        ...prev,
        [technicianId]: response?.data || [],
      }));
    } catch (error) {
      console.error(error);
      toast.error("Failed to load engineer details");
    }

    setLoadingTechnicianDetails(false);
  };
  const exportToExcel = async () => {
    try {
      if (!selectedMaterial?.length) {
        toast.error("Please select item");
        return;
      }

      const materialIds = selectedMaterial.map((m) => m.value);

      const response = await fetch(
        `${baseURL}api/export/material-stock-details`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            material_id: materialIds,
          }),
        },
      );

      if (!response.ok) {
        throw new Error("Failed to download file");
      }

      const blob = await response.blob();

      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = "material_stock.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error(error);
      toast.error("Export failed");
    }
  };

  return (
    <>
      <div className="page-content">
        <Breadcrumbs title={"View Stock"} breadcrumbItems={[]} />
        <div className="card mb-3">
          <div className="container-fluid p-4 ">
            <p className="text-muted pb-1">
              Fields marked with <span className="text-danger fw-bold">*</span>{" "}
              are required.
            </p>
            <form onSubmit={handleFormSubmit}>
              <div className="row mb-3">
                <div className="col-12 col-md-8">
                  <div className="row align-items-center">
                    <div
                      className="col-12 col-md-6"
                      style={{ minHeight: "85px" }}
                    >
                      <MultiSelectInput
                        label="Select Item"
                        options={materialOptions}
                        value={selectedMaterial}
                        onMultiSelect={(selectedOptions) => {
                          handleChange({
                            target: {
                              name: "material",
                              value: selectedOptions || [],
                            },
                          });
                        }}
                        placeholder="Select Item"
                        labelClassName="form-label"
                        isClearable={true}
                        asterisk={true}
                        customError={errors.material}
                      />
                    </div>
                    <div className="col-6">
                      <button
                        type="submit"
                        className="btn btn-primary"
                        style={{
                          height: "38px",
                          width: "80px",
                          fontSize: "13px",
                          marginTop: "10px",
                          marginRight: "10px",
                        }}
                      >
                        GO
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          {loadingData && (
            <div style={loaderOverlay}>
              <LoaderCreatePage />
            </div>
          )}
        </div>
        {showStockData && (
          <div className="">
            <div className="card mt-4 p-3">
              <Row className="mt-2">
                <Col
                  style={{
                    marginLeft: "",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <h5 className="card-header">Stock Details</h5>
                  <button
                    type="button"
                    onClick={exportToExcel}
                    className="btn btn-success d-flex align-items-center gap-2"
                    style={{
                      fontSize: "13px",
                      marginTop: "10px",
                    }}
                  >
                    <Download size={16} />
                    Export To Excel
                  </button>
                </Col>

                <div
                  className="table mt-2"
                  style={{
                    maxHeight: "450px",
                    overflowY: "auto",
                    width: "100%",
                    scrollBehavior: "smooth",
                  }}
                >
                  <table className="table table-bordered fw-bold">
                    <thead
                      style={{
                        fontWeight: "700",
                        top: 0,
                        backgroundColor: "#f9992d",
                        zIndex: 1,
                      }}
                    >
                      <tr>
                        <th>
                          {" "}
                          <strong> Sr. No </strong>
                        </th>
                        <th>GMDS Code</th>
                        <th>Item Description</th>
                        <th>Total Quantity</th>
                        <th>Total Available Quantity</th>
                        <th>Engineers Assigned Quantity</th>
                        <th>Engineers Used Quantity</th>
                        <th>Engineers Remaining Quantity</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {/* 🔹 No Inventory Data */}
                      {inventoryData?.length === 0 && !loadingData && (
                        <tr>
                          <td
                            colSpan="9"
                            className="text-center text-muted py-3"
                          >
                            There are no records to display
                          </td>
                        </tr>
                      )}

                      {inventoryData?.length > 0 &&
                        inventoryData?.map((row, index) => {
                          const isExpanded = expandedRows[row?.material_id];
                          const technicians =
                            techniciansByMaterial[row?.material_id] || [];

                          return (
                            <React.Fragment key={row?.material_id}>
                              {/* 🔹 Inventory Row */}
                              <tr>
                                <td>{index + 1}</td>
                                <td style={{ minWidth: 200 }}>
                                  {row?.material_gmds_code || row?.material_name}
                                </td>
                                <td style={{ minWidth: 200 }}>
                                  {row?.material_descriptions || "-"}
                                </td>
                                <td>{row?.total_qty}</td>
                                <td>{row?.total_available_quantity}</td>
                                <td>{row?.assigned_quantity}</td>
                                <td>{row?.used_quantity}</td>
                                <td>{row?.remaining_quantity}</td>
                                <td>
                                  <button
                                    type="button"
                                    className={`btn btn-sm ${
                                      isExpanded
                                        ? "btn-info"
                                        : "btn-outline-info focus-ring"
                                    }`}
                                    onClick={() =>
                                      getTechniciansByMaterial(row.material_id)
                                    }
                                  >
                                    <span
                                      className="fw-bold"
                                      style={{ fontSize: "15px" }}
                                    >
                                      {isExpanded ? "−" : "+"}
                                    </span>
                                  </button>
                                </td>
                              </tr>

                              {/* 🔹 Expanded Section */}
                              {isExpanded && (
                                <tr className="bg-light">
                                  <td colSpan="9">
                                    {technicians?.length === 0 &&
                                    !loadingTechnicians ? (
                                      <div className="text-center text-muted py-3">
                                        No assigned engineers of this item!
                                      </div>
                                    ) : (
                                      <table className="table table-sm table-bordered mb-0">
                                        <thead
                                          style={{
                                            fontWeight: "700",
                                            top: "68px",
                                            backgroundColor: "#ddd",
                                            zIndex: 1,
                                          }}
                                        >
                                          <tr>
                                            <th style={{ fontWeight: 700 }}>
                                              Engineer Name
                                            </th>
                                            <th style={{ fontWeight: 700 }}>
                                              Assigned Qty
                                            </th>
                                            <th style={{ fontWeight: 700 }}>
                                              Used Qty
                                            </th>
                                            <th style={{ fontWeight: 700 }}>
                                              Returned Qty
                                            </th>
                                            <th style={{ fontWeight: 700 }}>
                                              Remaining Qty
                                            </th>
                                            <th style={{ fontWeight: 700 }}>
                                              Action
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {technicians?.map((tech) => {
                                            const isTechExpanded =
                                              expandedTechnician ===
                                              tech.technician_id;
                                            const techDetails =
                                              technicianDetails[
                                                tech.technician_id
                                              ] || [];

                                            return (
                                              <React.Fragment
                                                key={tech.technician_id}
                                              >
                                                {/* 🔹 Engineer Row */}
                                                <tr>
                                                  <td>
                                                    {tech.technician_name}
                                                  </td>
                                                  <td>
                                                    {tech.assigned_quantity}
                                                  </td>
                                                  <td>{tech.used_quantity}</td>
                                                  <td>{tech.return_qty}</td>
                                                  <td>
                                                    {tech.remaining_quantity}
                                                  </td>
                                                  <td>
                                                    <button
                                                      type="button"
                                                      className={`btn btn-sm ${
                                                        isTechExpanded
                                                          ? "btn-info"
                                                          : "btn-outline-info focus-ring"
                                                      }`}
                                                      onClick={() =>
                                                        getTechnicianDetails(
                                                          row?.material_id,
                                                          tech?.technician_id,
                                                        )
                                                      }
                                                    >
                                                      <span
                                                        className="fw-bold"
                                                        style={{
                                                          fontSize: "15px",
                                                        }}
                                                      >
                                                        {isTechExpanded
                                                          ? "−"
                                                          : "+"}
                                                      </span>
                                                    </button>
                                                  </td>
                                                </tr>

                                                {/* 🔹 Engineer Expanded Section */}
                                                {isTechExpanded && (
                                                  <tr className="bg-white">
                                                    <td colSpan="5">
                                                      {loadingTechnicianDetails ? (
                                                        <div className="text-center py-3">
                                                          Loading details...
                                                        </div>
                                                      ) : techDetails.length ===
                                                        0 ? (
                                                        <div className="text-center text-muted py-3">
                                                          No details available
                                                        </div>
                                                      ) : (
                                                        <table className="table table-sm table-bordered mb-0">
                                                          <thead className="table-secondary">
                                                            <tr>
                                                              <th>Type</th>
                                                              <th>
                                                                Assigned By
                                                              </th>
                                                              <th>Quantity</th>
                                                              <th>Date</th>
                                                            </tr>
                                                          </thead>
                                                          <tbody>
                                                            {techDetails.map(
                                                              (detail, i) => (
                                                                <tr key={i}>
                                                                  <td>
                                                                    {{
                                                                      technician_return:
                                                                        "Return",
                                                                      job_cards:
                                                                        "Used",
                                                                      technician_inventory:
                                                                        "Assigned",
                                                                    }[
                                                                      detail
                                                                        .type
                                                                    ] || "-"}
                                                                  </td>
                                                                  <td>
                                                                    {detail
                                                                      ?.technician_inward
                                                                      ?.createdBy
                                                                      ?.first_name ||
                                                                      "-"}{" "}
                                                                    {detail
                                                                      ?.technician_inward
                                                                      ?.createdBy
                                                                      ?.last_name ||
                                                                      "-"}
                                                                  </td>
                                                                  <td>
                                                                    {detail.type ===
                                                                    "technician_return"
                                                                      ? detail
                                                                          ?.technician_return
                                                                          ?.return_qty
                                                                      : detail?.type ===
                                                                          "technician_inventory"
                                                                        ? detail
                                                                            ?.technician_inward
                                                                            ?.quantity
                                                                        : detail.type ===
                                                                            "job_cards"
                                                                          ? detail?.required_qty
                                                                          : "-"}
                                                                  </td>

                                                                  <td>
                                                                    {!detail?.updatedAt ||
                                                                    loadingTechnicianDetails
                                                                      ? "-"
                                                                      : formatDateTime(
                                                                          detail?.updatedAt,
                                                                        )}
                                                                  </td>
                                                                </tr>
                                                              ),
                                                            )}
                                                          </tbody>
                                                        </table>
                                                      )}
                                                    </td>
                                                  </tr>
                                                )}
                                              </React.Fragment>
                                            );
                                          })}
                                        </tbody>
                                      </table>
                                    )}
                                  </td>
                                </tr>
                              )}
                            </React.Fragment>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </Row>
              {loadingTechnicians && (
                <div style={loaderOverlay}>
                  <LoaderCreatePage />
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ViewStock;
